export enum BusinessSegmentIds{
    Mycogen = 8,
    Brevant = 524288
}

export enum BusinessSegmentShortDesc{
    _8 = 'Mycogen',
    _524288 = 'Brevant'
  }